/* Libs */
import Segment from '../index';

/**
 * -------------------------------------------------------------------------------------
 * Define the "event name" here, in TRACKING_TYPES
 */

export const TRACKING_TYPES = {
  surveyStarted: 'Started Survey',
  surveyQuestionFinished: 'Survey Question Finished',
  surveyQuestionStarted: 'Survey Question Started',
  finishedSurvey: 'Finished Survey',
  recommendationClicked: 'Recommendation Clicked',
  userSignUpFlow: 'User Sign Up Flow',
};

export type THomeHubTrackAttributes = Partial<{
  user_id: string | number;
  survey_name: string;

  question_id: string | number;
  question_name: string;
  question_answers: any;

  recommendation_id: string | number;
  recommendation_name: string;
  recommendation_action: string;

  user_email: string;
  user_name: string;
  user_step: string;
}>;

export const SegmentTrackingAction = {
  /* generic survey/reco tracking event: all similiar so we can bundle up */
  homeHubTracking(trackAttributes: THomeHubTrackAttributes, trackType: string) {
    const payload = {
      ...trackAttributes,
    };

    Segment.track(trackType, payload);
  },
  homeHubIdentify(trackAttributes: THomeHubTrackAttributes, trackType: string) {
    const payload = {
      ...trackAttributes,
    };

    Segment.track(trackType, payload);
  },
};
